import * as common_components from "../editor_common_components.js"
import * as react_components from "../reactcomponent.js"
import { Button } from "../../core/components/button.js";
import React from "react"
export class EntityFieldPicker extends React.Component<any, any>{
    constructor(props: any, context: any) {
        super(props, context);
        this.state = { showEntityFieldPicker: false, currentValue: props.value, initialValue: props.value };
    }

    handleShowEntityFieldPicker = () => {
        this.setState({ showEntityFieldPicker: true });
    }

    handleClose = () => {
        this.setState({ showEntityFieldPicker: false });
    }

    handleSave = (name) => {
        this.props.onTextChange(name);
        this.setState({ showEntityFieldPicker: false });
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({ currentValue: props.value, initialValue: props.value });
    }

    handleChange = (event) => {
        this.setState({ currentValue: event.target.value });
    }

    handleBlur = (event) => {
        if (this.state.currentValue != this.state.initialValue) {
            this.props.onTextChange(this.state.currentValue);
        }
    }

    render() {
        var d;

        if (this.state.showEntityFieldPicker === true) {
            d = <EntityFieldPickerDialog
                contextVariables={this.props.contextVariables}
                onClose={this.handleClose}
                onSave={this.handleSave}
                entityFields={this.props.entityFields}
            />
        }
        return (
            <li>
                {d}
                <div title={this.props.label}>
                    <span className="property-name">
                        <common_components.RightFloatingButtonScalor>
                            <Button iconName="search" title="Suche" handleClick={this.handleShowEntityFieldPicker}></Button>
                        </common_components.RightFloatingButtonScalor>
                        {this.props.label}
                    </span>
                    <div className="c" style={{ "whiteSpace": "nowrap" }}>
                        <input style={{ backgroundColor: "lightgray" }} readOnly={true} type="text" value={this.state.currentValue || ''} onChange={this.handleChange} onBlur={this.handleBlur} />
                    </div>
                </div>
            </li>
        );
    }
};


export class EntityFieldPickerDialog extends React.Component<any, any>{
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleClose = () => {
        this.props.onClose();
    }

    handleSave = (selectedItem) => {
        this.props.onSave("entity." + selectedItem.FieldName);
    }

    render() {
        const columns = [{ field: "FieldName", title: "Column name" }];
        const entityKeys = Object.keys(this.props.entityFields);

        let data = entityKeys.filter(value => value != "IndividualFields")
            .map((ef) => { return { FieldName: ef } });

        if (this.props.entityFields.IndividualFields) {
            const individualFieldsData = Object.keys(this.props.entityFields.IndividualFields).map(ef => { return { FieldName: "IndividualFields." + ef } });
            data = data.concat(individualFieldsData);
        }
        data = data.sort((a, b) => { return a.FieldName.localeCompare(b.FieldName) });

        return (
            <react_components.BasicDialog title="Select column" onClose={this.handleClose}>
                <react_components.KendoGrid filtermode="row" data={data} columns={columns} OnSelectedItemChanged={this.handleSave} />
            </react_components.BasicDialog>
        );
    }
};